import type { ChallengeStatus } from "../api/languageChallenge";
import type { User } from "../api/v2";
import styles from "../styles/ChallengeRun.module.scss";

import Landing from "./Landing";
import RegisteredPage from "./RegisteredPage";

export interface Props {
  challengeStatus: ChallengeStatus;
  user: User;
}

/**
 * Represents a single challenge. There may be more than one
 * challenge, for example, if we concurrently run a Language and Mega chalenge
 */
const ChallengeRun = ({ challengeStatus, user }: Props) => (
  <div className={styles["wrap"]}>
    <Landing challenge={challengeStatus.challenge} />
    <RegisteredPage
      shownChallenge={challengeStatus.challenge}
      status={challengeStatus.status}
      user={user}
    />
  </div>
);

export default ChallengeRun;
